"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var remove_1 = tslib_1.__importDefault(require("lodash/remove"));
var join_1 = tslib_1.__importDefault(require("lodash/join"));
var filter_1 = tslib_1.__importDefault(require("lodash/filter"));
var reduce_1 = tslib_1.__importDefault(require("lodash/reduce"));
var actions_1 = require("../actions");
var removeStyle = function (styles, name) {
    var copy = styles.slice();
    remove_1.default(copy, function (styleDef) { return styleDef.name === name; });
    return copy;
};
var registerStyle = function (styles, _a) {
    var name = _a.name, classNames = _a.classNames;
    var copy = removeStyle(styles, name);
    copy.push({ name: name, classNames: classNames });
    return copy;
};
exports.findStyle = function (styles) { return function (style) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var foundStyles = filter_1.default(styles, function (s) { return s.name === style; });
    return reduce_1.default(foundStyles, function (res, style) {
        if (typeof style.classNames === 'function') {
            return res.concat(style.classNames(args));
        }
        return res.concat(style.classNames);
    }, []);
}; };
exports.findStyleAsClassName = function (styles) { return function (style) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return join_1.default(exports.findStyle(styles)(style, args), ' ');
}; };
// TODO
exports.stylingReducer = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case actions_1.REGISTER_STYLE: {
            return registerStyle(state, {
                name: action.name,
                classNames: action.classNames
            });
        }
        case actions_1.REGISTER_STYLES: {
            return action.styles.reduce(function (allStyles, style) {
                return registerStyle(allStyles, style);
            }, state);
        }
        case actions_1.UNREGISTER_STYLE: {
            return removeStyle(state, action.name);
        }
        default:
            return state;
    }
};
//# sourceMappingURL=styling.js.map